<div
  class="ca-form-field-container"
  [class.error]="hasError"
  [class.disabled]="isDisabled"
>
  <ng-content></ng-content>
  @if (hasError) {
    <div class="errors">
      {{ "validation." + error | translate }}
    </div>
  }
</div>
